import React from "react"
import { Col, Container, Image, Row } from "react-bootstrap"
import Media from "react-media"
import { mediaQueries } from "./Anouncement"
import { whatsappURL } from "./Layout"

export default function SecondJumbotron() {
  return (
    <Media queries={mediaQueries}>
      {matches => (
        <div
          style={{
            backgroundImage: "url('/jumbotron-2.jpg')",
            backgroundSize: "cover",
            minHeight: 800,
          }}
        >
          <Container>
            <Row
              className="justify-content-center align-items-center"
              style={{
                minHeight: matches.tablet ? 800 : 400,
              }}
            >
              <Col
                style={{ padding: "3em 0em" }}
                className="text-center text-md-left"
              >
                <h1
                  className={`${
                    matches.tablet ? "display-4" : "h1"
                  } font-weight-800 font-style-italic`}
                >
                  Harga normal <s>Rp 199.000</s>{" "}
                </h1>
                <h2
                  className={` ${
                    matches.tablet ? "display-4" : "h1"
                  }  font-weight-800 font-style-italic `}
                >
                  Harga promo <span className="text-danger">Rp 159.000</span>
                </h2>
                <p className={`${matches.tablet ? "h3" : "lead"} my-4`}>
                  Pesan sekarang sebelum harga kembali normal !!
                </p>
                <p>GRATIS ONGKIRR !! khusus daerah jabodetabek</p>
                <a
                  target="_blank"
                  className="btn btn-danger btn-lg px-5 py-3 font-weight-bold"
                  href={`${whatsappURL}Halo%20kak%2C%0A%0AApakah%20stok%20kaos%20developernya%20masih%20ada%20%3F%20Saya%20mau%20pesan%20yang%20...`}
                >
                  Ya, saya mau pesan
                </a>
                {!matches.tablet && (
                  <div className="w-100 mt-5">
                    <Image src={`/two-men.png`} fluid />
                  </div>
                )}
              </Col>
            </Row>
          </Container>
        </div>
      )}
    </Media>
  )
}
